<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.blac }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'BL A/C')
                      " :class="$helpers
                        .requiredlabel(requirement, 'BL A/C')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <!-- <b-form-group label="BL A/C" label-for="blac" label-cols="12"> -->
                      <b-input-group>
                        <b-form-input type="text" v-model="item.blac" placeholder="Enter BL A/C" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.blac = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Trading Name')
                      " :class="$helpers
                        .requiredlabel(requirement, 'Trading Name')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm"></b-form-group>
                    <!-- <b-form-group label="Trading Name" label-for="shortname" label-cols="12"> -->
                    <b-input-group>
                      <b-form-input type="text" v-model="item.shortname" placeholder="Enter client short name"
                        size="sm"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.shortname = ''">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Legal Entity Name" label-for="name" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.name" placeholder="Enter client name"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.name = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Addressee" label-for="addressee" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.addressee" placeholder="Enter addressee"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.addressee = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Address line 1" label-for="address1" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address1" placeholder="Enter address line 1"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address1 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="City/Town" label-for="address2" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address2" placeholder="Enter city/town"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address2 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="State/Province/County" label-for="address3" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address3" placeholder="Enter state/province/county"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address3 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Country" label-for="countryiso2" label-cols="12">
                      <treeselect instanceId="country" type="number" v-model="item.countryiso2" :clearable="true"
                        :options="country_options"></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Post/Zip Code" label-for="address5" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address5" placeholder="Enter post/zip code"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address5 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!--   <b-col cols="12" sm="3">
              <b-form-group
                label="Postcode"
                label-for="postcode"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.postcode"
                    placeholder="Enter postcode"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.postcode = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Tel" label-for="phone" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.phone" placeholder="Enter phone no"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.phone = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Fax" label-for="fax" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.fax" placeholder="Enter fax" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.fax = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Email" label-for="email" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.email" placeholder="Enter email"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.email = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Vatable" label-for="vatable" label-cols="12">
                      <b-form-radio-group id="vatable" v-model="item.vatable" :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Attributes" label-for="attributes" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.attributes" placeholder="Attributes"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.attributes = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-row>
                      <b-col>
                        <b-form-group label="OnStop?" label-for="onstop" label-cols="12">
                          <b-form-radio-group id="onstop" v-model="item.onstop" :options="[
                            { text: 'Yes', value: true },
                            { text: 'No', value: false },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group> </b-form-group></b-col>
                      <b-col>
                        <b-form-group label="Active?" label-for="active" label-cols="12">
                          <b-form-radio-group id="active" v-model="item.active" :options="[
                            { text: 'Yes', value: true },
                            { text: 'No', value: false },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group> </b-form-group></b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Comments" label-for="comments" label-cols="12">
                      <b-form-textarea id="data" v-model="item.comments" placeholder="Comments" rows="6" max-rows="8"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group> </b-col></b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Supplier Type')
                      " :class="$helpers
                        .requiredlabel(requirement, 'Supplier Type')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <b-input-group class="treeselect_all" style="left:80px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="suppliertypeid"></i>
                      </b-input-group>
                      <b-tooltip target="suppliertypeid" triggers="hover" placement="top">Please refer to the 'Supplier
                        Types' table
                        to determine a default coding for the Nominal ledger.</b-tooltip>
                      <!-- <b-form-group label="Supplier Type" label-for="suppliertypeid" label-cols="12"> -->
                      <treeselect instanceId="suppliertypeid" type="number" v-model="item.suppliertypeid"
                        :clearable="true" :options="suppliertype_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="N/L Code" label-for="nlcode" label-cols="12">
                <treeselect
                  instanceId="nlcode"
                  type="number"
                  v-model="item.nlcode"
                  :clearable="true"
                  :options="nlcode_options"
                ></treeselect>
              </b-form-group>
            </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Account Currency" label-for="type" label-cols="12">
                      <treeselect instanceId="currency" type="number" v-model="item.currency" :clearable="true"
                        :options="currency_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Budget Currency" label-for="type" label-cols="12">
                      <treeselect instanceId="currency" type="number" v-model="item.budgetcurrency" :clearable="true"
                        :options="currency_options"></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>


        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left">
              <b-button squared size="sm" variant="primary" @click="saveit()"
                v-if="user.permissions.includes('suppliers.save')" :disabled="postit_disabled">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left ml-2 mt-1">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "SupplierEdit",
  watch: {
    "item.onstop": {
      immediate: true,
      handler(newVal, oldVal) {
        let newdata = this.item.attributes;
        if (!newdata) {
          newdata = "";
        }
        if (newVal) {
          if (!newdata.includes("/S ")) {
            newdata = "/S " + newdata;
          }
        } else {
          newdata = newdata.replace("/S ", "");
        }
        this.item.attributes = newdata;
      },
    },
  },
  data() {
    return {
      busy: false,
      requirement: {
        suppliertypeid: "Supplier Type",
        blac: "BL A/C",
        shortname: "Trading Name"
      },
      item: {
        name: null,
        shortname: null,
        // district: null,
        blac: null,
        suppliertypeid: null,
        eventcode: null,
        address1: null,
        address2: null,
        address3: null,
        address4: null,
        countryiso2: null,
        address5: null,
        phone: null,
        fax: null,
        email: null,
        comments: null,
        balance: null,
        vatable: false,
        currency: null,
        budgetcurrency: null,
        region: null,
        summary: null,
        web: null,
        bankdetails: null,
        terms: null,
        onstop: false,
        active: true,
        attributes: null,
        created_at: this.$moment().format("YYYY-MM-DD"),
        created_by: null,
      },
      country_options: [],
      // nlcode_options: [],
      suppliertype_options: [],
      currency_options: [],
      options: {
        title: "Supplier",
        icon: "fa fa-industry",
      },
    };
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_countries {
              setup_countries {
                id: code
                label
              }
            }
          `,
        });
        this.country_options = response.data.setup_countries;
        console.log(this.country_options);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query salesgroups {
              salesgroups {
                id
                label: id
              }
            }
          `,
        });
        this.salesgroups_options = response.data.salesgroups;
      } catch (error) {
        console.log(error);
      }

      // try {
      //   const response = await this.$apollo.query({
      //     query: gql`
      //       query nlcodes {
      //         nlcodes {
      //           id
      //           label
      //         }
      //       }
      //     `,
      //   });
      //   this.nlcode_options = response.data.nlcodes;
      // } catch (error) {
      // }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
              }
            }
          `,
        });
        this.suppliertype_options = response.data.suppliertypes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_currencies {
              setup_currencies {
                id:code
                label
              }
            }
          `,
        });
        this.currency_options = response.data.setup_currencies;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliers($id: String, $dateformat: String) {
              suppliers(id: $id, dateformat: $dateformat) {
                id
                name
                shortname
                # district
                blac
                suppliertypeid
                nlcode
                eventcode
                addressee
                address1
                address2
                address3
                address4
                countryiso2
                address5
                phone
                fax
                email
                comments
                balance
                vatable
                currency
                budgetcurrency
                region
                summary
                web
                bankdetails
                terms
                onstop
                active
                attributes
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.suppliers.length > 0) {
          this.item = response.data.suppliers[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {

      let row = this.cleanit(this.item);

      this.message = this.$helpers.mandatoryFields(
        {
          suppliertypeid: "Supplier Type",
          blac: "BL A/C",
          shortname: "Trading Name"
        },
        row
      );

      if (this.message.length > 0) {
        return;
      }


      this.busy = true;

      let variables = { rows: [row] };
      if (this.config.action == 'copy') {
        variables.rows[0].id = null
      }
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation suppliers_save(
              $rows: [Supplier_input]
            ) {
              suppliers_save(rows: $rows) {
                id
                name
                shortname
                # district
                blac
                suppliertypeid
                nlcode
                eventcode
                addressee
                address1
                address2
                address3
                address4
                countryiso2
                address5
                phone
                fax
                email
                comments
                balance
                vatable
                currency
                budgetcurrency
                region
                summary
                web
                bankdetails
                terms
                onstop
                active
                attributes
              }
            }
          `,
          variables,
        });
        if (response.data.suppliers_save.length > 0) {
          this.item = response.data.suppliers_save[0];
        }
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>